import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import InputSelect from "./InputSelect"
import SelectControl from "./SelectControl"
import SelectInput from "./SelectInput"
import SelectClearIndicator from "./SelectClearIndicator"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"

import InputError from "../Field/InputError"
import Translate from "../../Translate"

export function SelectField(props) {
  const {
    className,
    schema,
    onLoadingMessage,
    onNoOptions,
    error,
    id,
    type = "FIXED",
    isClearable = true,
    touched = false,
    ...rest
  } = props

  const errorId = `${id}-error`

  return (
    <div
      className={classNames("oj-select-field", className, _.kebabCase(type), {
        "state-error": error?.hasError,
        "state-touched": touched && !error?.hasError,
        clearable: isClearable
      })}
    >
      <InputSelect
        {...schema}
        {...rest}
        components={{
          Control: SelectControl,
          Input: SelectInput,
          ClearIndicator: SelectClearIndicator
        }}
        isClearable={isClearable}
        type={type}
        loadingMessage={onLoadingMessage}
        noOptionsMessage={onNoOptions}
        id={id}
        error={error}
      />
      {error?.hasError && (
        <InputError id={errorId}>
          <Translate id={error.key} data={error.params} />
        </InputError>
      )}
    </div>
  )
}

SelectField.propTypes = {
  className: PropTypes.string,
  isClearable: PropTypes.bool,
  schema: PropTypes.shape(fieldSchemaPropTypes),
  type: PropTypes.oneOf(["FIXED", "SEARCHABLE", "ASYNC"]),
  onLoadingMessage: PropTypes.func,
  onNoOptions: PropTypes.func,
  error: PropTypes.shape({
    hasError: PropTypes.bool,
    key: PropTypes.string,
    params: PropTypes.object
  }),
  id: PropTypes.string,
  touched: PropTypes.bool
}

export default SelectField
